// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__26guW","validationTips":"StatementDescriptor_validationTips__25V76"};